/* eslint-disable spellcheck/spell-checker */
import { useI18n } from 'common-module/src/util/useI18n';
import config from 'common-module/src/config';

/**
 * 获取路径的名称
 * @param path
 * @returns {*[]}
 */
export const getPathName = path => path.split('/')
  .filter(k => !k.startsWith('.') && !k.startsWith('/'))
  .map(k => k.toLowerCase())
  .map(k => k.endsWith('.js') ? k.replace('.js', '') : k);

/**
 * 自动导入
 * @param requireFiles
 * @param filter 过滤器
 */
export const autoImport = (requireFiles, filter = () => true) => {
  return requireFiles.keys().filter(filter).reduce((result, key) => ({
    ...result,
    [getPathName(key).reverse()[0]]: requireFiles(key).default
  }), {});
};

                 
/**
 * 是否为海外版
 * @type {boolean}
 */
export const isOverseasVersion = true;
        
                           
                                                
         

              
/**
 * 是否为私有部署版本
 * @type {boolean}
 */
export const isPrivateVersion = true;
        
                           
                                               
         

export const isSupportRecorderART = isOverseasVersion;
/**
 * 获取 demo path
 * @param {Event} e
 */
export const getComposedPath = (e) => {
  return e.path || ((e) => {
    // 如果存在节点直接返回
    if (e.path) {
      return;
    }
    // 如果不存在节点，则通过遍历获取
    let target = e.target;
    e.path = [];
    while (target.parentNode !== null) {
      e.path.push(target);
      target = target.parentNode;
    }
    e.path.push(document, window);
    return e.path;
  })(e);
};

/**
 * 删除LIGA indexedDB
 * @param {*} appDbName 对应 config.VUE_APP_DB_NAME
 * @param {*} userId
 */
export const deleteIndexedDB = (appDbName, userId, orgId) => {
  if (!window.indexedDB || !appDbName || !userId) {
    return;
  }
  const dbName = `${appDbName}:${btoa(String(userId))}:${btoa(String(orgId))}`;
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.deleteDatabase(dbName);
    request.onsuccess = () => {
      resolve();
    };
    request.onerror = () => {
      reject();
    };
  });
};


export const getFileSuffix = (fileUrl) => {
  return fileUrl?.substring(fileUrl.lastIndexOf('.'));
};

export const isImage = (name) => {
  return ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.ico'].includes(
    getFileSuffix(name)
  );
};
export const getLastFilterOption = (Options, userId) => {
  const lastOptions = Options.filter(o => (o.lastVisitIndex && o.userId !== userId));
  if (lastOptions.length <= 3) {
    return lastOptions.sort((a, b) => b.lastVisitIndex - a.lastVisitIndex);
  }
  return lastOptions.sort((a, b) => b.lastVisitIndex - a.lastVisitIndex).slice(0, 3);
};
export const getGroup = (userOptions, userId) => {
  if (userOptions.length < 10) {
    return [{ key: 'residue', label: '', options: userOptions }];
  }
  const { t } = useI18n();
  const lastOptions = getLastFilterOption(userOptions, userId);
  const selfGroup = { key: 'self', label: '', options: [] };
  const lastVisitGroup = { key: 'lastVisit', label: t('issue.recentOptions'), options: lastOptions };
  const residueGroup = { key: 'residue', label: '', options: [] };
  const groups = [];
  const lastIds = lastOptions.map(item => item.userId);
  userOptions.forEach(element => {
    if (userId === element.userId) {
      selfGroup.options.push(element);
      return;
    }
    if (!lastIds.includes(element.userId)) {
      residueGroup.options.push(element);
    }
  });
  // if (selfGroup.options.length > 0){
  //   groups.push(selfGroup);
  // }
  lastVisitGroup.options = lastVisitGroup.options.filter(item =>item?.accountEnabled !== -1);
  if (lastVisitGroup.options.length > 0) {
    groups.push(lastVisitGroup);
  }
  residueGroup.options = selfGroup.options.concat(residueGroup.options);
  if (residueGroup.options.length > 0) {
    groups.push(residueGroup);
  }
  return groups;
};
export const getRecentIds = (recentMap) => {
  const recentList = Object.entries(recentMap);
  recentList.sort((a, b) => {
    return b[1] - a[1];
  });
  const newRecentList = recentList.length > 3 ? recentList.slice(0, 3) : recentList;
  return Object.fromEntries(newRecentList);
};

const localMap = { zh: 'cn', en: 'us' };

export function getLocale(locale) {
  locale = locale ? (localMap[locale] || locale) : null;
  return locale || (isOverseasVersion ? 'us' : 'cn');
}

/**
 * 重新加载国际化
 * @param locale 语言
 * @returns {Promise<unknown>}
 */
export function reloadI18n(locale) {
  return new Promise((resolve, reject) => {
    let script = document.querySelector('script#i18n');
    if (script) {
      script.parentNode.removeChild(script);
    }
    script = document.createElement('script');
    script.id = 'i18n';
    locale = getLocale(locale);
    const env = config.VUE_APP_ENV === 'prod' ? '/' : '/qa/';
    script.onload = () => resolve(locale);
    script.onerror = reject;
    script.dataset.locale = locale;
    script.src = `${config.VUE_APP_CDN_URL}${env}static/i18n/i18n.${locale}.js?v=${Date.now()}`;
    document.head.appendChild(script);
    if (window.setMQLanguage) {
      window.setMQLanguage(locale);
    }
  });
}

/**
 * 重新加载国际化（如果当前加载的一致，则不处理）
 * @param locale
 * @returns {Promise<*>|Promise<void>}
 */
export function ifReloadI18n(locale) {
  const script = document.querySelector(`script#i18n[data-locale="${getLocale(locale)}"]`);
  if (script) {
    return Promise.resolve(false);
  }
  return reloadI18n(locale);
}

export const scrollToTopByDistance = (scrollContainer, el, distance = 0) => {
  // 滚动容器与目标元素屏幕距离
  const diff = el.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top;
  const val = diff - distance;
  const { scrollTop } = scrollContainer;
  if (scrollTop >= val + scrollTop) {
    return;
  }
  scrollContainer.scrollBy(0, val);
};

export const sleep = function(timeout) {
  if (timeout < 0) {
    timeout = 0;
  }
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, timeout);
  });
};
